
const m = window.require("@ember/-internals/metal/index");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
